import React, {DOMAttributes} from 'react'

type CustomElement<T, K extends string> = Partial<T & DOMAttributes<T> & {children: any}>
declare global {
  namespace JSX {
    interface IntrinsicElements {
      ['em-emoji']: CustomElement<any, string>
    }
  }
}

export function EmEmoji(props) {
  return <em-emoji {...props} />
}
